module.exports = __webpack_public_path__ + "img/lamps-sprite-1x.b76b0f2d.png";